import { Icon } from '@vista-digital/occ-ui/src'
import type { FC } from 'react'
import { CmsLinkComponent } from '@/cms/components/cmsLink/CmsLink'
import { cmsDataService } from '../../../../../services/cms.data.service'
import type { HeaderLinksPropsApi } from '../models'

interface NavSubLinksProps {
    selectedLink?: HeaderLinksPropsApi | null
    setSelectedLink: (link: HeaderLinksPropsApi | null) => void
}

export const NavSubLinks: FC<NavSubLinksProps> = ({ selectedLink, setSelectedLink }) => {
    const backButtonLabel = cmsDataService.get().headerLinksBackButtonLabel ?? 'Back'
    const maxSublinks: number = 5

    return (
        <div className={`nav-sublink-container ${selectedLink ? 'expanded' : ''}`}>
            <div onClick={() => setSelectedLink(null)}>
                <Icon className="nav-arrow back-icon" name="arrowLeft" />
                {backButtonLabel}
            </div>
            <div className="nav-sublink-header">{selectedLink?.primaryPageName}</div>
            {selectedLink?.sublinks
                ?.slice(0, maxSublinks)
                .map((sublink, index) => (
                    <CmsLinkComponent
                        link={sublink}
                        key={'nav-sublink-' + index}
                        className="nav-link nav-multi-link nav-sublink"
                    />
                ))}
        </div>
    )
}
